<template>
  <div>
    <div style="max-height: 260px; overflow: auto; margin-left: 12px" id="style-2">
      <table class="tutor-study-result-table">
        <thead>
        <tr>
          <th>Buổi kiểm tra</th>
          <th style="min-width: 100px; max-width: 100px">Overall</th>
          <th style="min-width: 100px; max-width: 100px">Nghe</th>
          <th style="min-width: 100px; max-width: 100px">Nói</th>
          <th style="min-width: 100px; max-width: 100px">Đọc</th>
          <th style="min-width: 100px; max-width: 100px">Viết</th>
        </tr>
        </thead>
        <tbody v-if="tests && tests.length > 0">
        <tr v-for="(item, index) in tests" :key="index + 'selfStudyTest'">
          <td>
            <div class="d-flex align-center">
              <div style="width: 40%; text-align: start">
                <b>
                  {{item.courseName}}
                </b>
              </div>
              <div class="ml-4" style="width: 60%; text-align: start">
                {{item.categoryName}} <span v-if="item.gradingScale">({{GRADING_SCALE[item.gradingScale]}})</span>
              </div>
            </div>
          </td>
          <td>
            <div v-if="item.overall" class="d-flex align-center justify-center">
              {{item.overall.score}}
            </div>
          </td>
          <td v-for="(skill, index) in skills" v-bind:key="index + 'skill'">
            <div v-if="item.skills && item.skills.some((e) => e.folderName === skill)">
              <div style="color: #0180C7" class="d-flex align-center justify-center">
                {{getScoreBySkill(item, skill, 'score')}} <span v-if="getScoreBySkill(item, skill, 'score') === 'hundredScore'">/100</span>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="6">
            <span style="color: red">Không có dữ liệu</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-left: 12px; margin-top: 40px"><span style="font-weight: bold">Ghi chú:</span> <span style="font-style: italic">So sánh tăng giảm trong điểm kiểm tra sẽ so sánh với bài kiểm tra theo kỹ năng gần nhất trước đó có cùng hệ điểm.</span></div>
  </div>
</template>

<script>
import BlendedCareRepository from '@/services/BlendedCareRepository';
import { GRADING_SCALE } from '@/modules/student_care/constant/constant';
import { mapState } from 'vuex';

export default {
  name: 'SelfStudyTest',
  components: {},
  data() {
    return {
      GRADING_SCALE,
      tests: [],
      skills: ['Listening', 'Speaking', 'Reading', 'Writing'],
    };
  },
  created() {
    this.getSelfStudyTestResult();
  },
  computed: {
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail']),
  },
  methods: {
    getScoreBySkill(item, skill, type) {
      const skillObject = item.skills.find((e) => e.folderName === skill);
      const scoreField = this.getFieldByGradingScale(skillObject.gradingScale, type);
      return skillObject[scoreField];
    },
    getFieldByGradingScale(gradingScale, type) {
      switch (gradingScale) {
        case 0:
          return type === 'score' ? 'pointQuestion' : '';
        case 1:
          return type === 'score' ? 'bandScore' : 'comparePointBand';
        case 2:
          return type === 'score' ? 'hundredScore' : 'comparePointHundred';
        case 3:
          return type === 'score' ? '' : '';
        case 4:
          return type === 'score' ? 'tenScore' : 'comparePointTen';
        default:
          return '';
      }
    },
    async getSelfStudyTestResult() {
      const loading = this.$loading.show();
      const result = await BlendedCareRepository.getSelfStudyTestResult({
        // lms_core_user_id: 1096533,
        // lms_core_user_id: 1172186,
        lms_core_user_id: this.studentBlendedTutorDetail.lms_core_user_id,
      });
      if (result.message === 'Success') {
        this.tests = result.data;
      }
      loading.hide();
    },
  },
};
</script>

<style scoped lang="scss">
.tutor-study-result-table {
  border-spacing: 0;
  width: 100%;
}
.tutor-study-result-table {
  width: 100%;
  max-height: 250px;
  overflow: auto;
  thead {
    position: sticky;
    top: 0;
    z-index: 10;
    tr th {
      min-width: 80px;
      text-align: center;
      padding: 12px 16px;
      background: #4D4CAC;
      color: #fff;
    }
  }
  tbody {
    tr {
      td {
        padding: 16px;
        text-align: center;
        border-bottom: 1px solid #fff;
        background: #F9F4F4;
        color: #000;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .tutor-study-result-table {
    font-size: 12px;
    thead {
      tr th {
        padding: 8px 8px;
      }
    }
    tbody {
      tr {
        td {
          padding: 8px;
        }
      }
    }
  }
}
</style>
